import React, { Component } from 'react';
import './Toggle.css';

export default class Toggle extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: this.props.value || 1
		};
	}

	componentDidMount = () => {
		let maxWidth = this.option1.getClientRects()[0].width;
		if (this.option2.getClientRects()[0].width > maxWidth) maxWidth = this.option2.getClientRects()[0].width;
		this.setState({ maxWidth: maxWidth - 20 });
	};

	_firstClasses = () => {
		if (this.state.selected === 1) return 'selected';
	};

	_secondClasses = () => {
		if (this.state.selected === 2) return 'selected';
	};

	_selectFirst = () => {
		this.setState({ selected: 1 });
	};

	_selectSecond = () => {
		this.setState({ selected: 2 });
	};

	getValue = () => {
		return this.state.selected;
	};

	_handleToggleChangeFirst = () => {
		if (this.props.valueChange) {
			this.props.valueChange();
		}
		this._selectFirst();
	};
	_handleToggleChangeSecond = () => {
		if (this.props.valueChange) {
			this.props.valueChange();
		}
		this._selectSecond();
	};

	render() {
		return (
			<div className="g-toggle">
				<div
					tabIndex="0"
					ref={(ref) => (this.option1 = ref)}
					style={{ width: this.state.maxWidth }}
					onClick={this._handleToggleChangeFirst}
					className={this._firstClasses()}
				>
					{this.props.option1}
				</div>
				<div
					tabIndex="0"
					ref={(ref) => (this.option2 = ref)}
					style={{ width: this.state.maxWidth }}
					onClick={this._handleToggleChangeSecond}
					className={this._secondClasses()}
				>
					{' '}
					{this.props.option2}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/inputs/toggle/Toggle.jsx